<template>
		<div id="pageRoot">
			<div class="pageElement text-box-a hover-animation-a" id="textBox01" style="background-image: url(/pages/img/sordo/svgPage78Textbox01.svg)">
				<p class="textBase" id="textBox01Text">
					Escribe el título<br>
					que señalaste en<br>
					la tapa del libro.
				</p>
			</div>

			<div id="tag01" class="tag" style="z-index: 3; top: 50px;" ref="tg1">
				<p class="textBase tagText">
					Venancio vuela bajito
				</p>
			</div>
			<div id="tag02" class="tag" style="z-index: 3; top: 110px;" ref="tg2">
				<p class="textBase tagText">
					Valentín salta bajito
				</p>
			</div>
			<div id="tag03" class="tag" style="z-index: 3; top: 170px;" ref="tg3">
				<p class="textBase tagText">
					Venancio vuela bonito
				</p>
			</div>
			<div id="tag04" class="tag" style="z-index: 3; top: 230px;" ref="tg4">
				<p class="textBase tagText">
					Valentín vuela bajito
				</p>
			</div>

			<div class="pageElement appearAnimationA" id="book" style="background-image: url(/pages/img/sordo/svgPage78Book.svg)">
				<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01" class="pageElement" style=
			"z-index: 7"/>
			</div>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-write"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#textBox01
{
position: absolute;
width: 363px;
height: 313.35px;
left: 626px;
top: 322px;
}
#textBox01Text
{
position: absolute;
width: 296px;
height: 151px;
left: 44px;
top: 45px;

font-size: 36px;
line-height: 49px;

color: #FBF8F8;
}
.tag{
position: absolute;
width: 400px;
height: 70.55px;
right: 10px;

background-image: url(/pages/img/sordo/svgPage71TagLongOFF.svg);
background-size: cover;
transform: scale(0.8);
transition: 0.3s;
}
.tag:hover{
transform: translateY(-10px) scale(0.9);
}
#inputField01
{
position: absolute;
width: 331px;
height: 49px;
left: 64px;
top: 488px;

font-size: 33px;
}
#book
{
position: absolute;
width: 504px;
height: 588px;
left: 101px;
top: 85px;
}
</style>

<script>
export default {
computed: {
dbId(){
//78 because we refer to the option selected on page 78, that is what we want to get.
return `${this.$route.params.type}-${this.$route.params.chapter}-${this.$route.params.number-1}-nombreLibro`
},          
},
async created() {
var value = await this.$db.options.get({
id: this.dbId,
}).catch(function(error){
console.log("error getting option" + error);
});
if (value === undefined) return;
console.log("loaded value");
console.log(value);

if (value.option === 1){
this.$refs.tg1.style["background-image"] = 'url(/pages/img/sordo/svgPage71TagLong.svg)';
}
else if (value.option === 2)
{
this.$refs.tg2.style["background-image"] = 'url(/pages/img/sordo/svgPage71TagLong.svg)';
}
else if (value.option === 3) {
this.$refs.tg3.style["background-image"] = 'url(/pages/img/sordo/svgPage71TagLong.svg)';
}
else {
this.$refs.tg4.style["background-image"] = 'url(/pages/img/sordo/svgPage71TagLong.svg)';
}
},
}
</script>